import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useAuth } from "oidc-react"
import { useEffect } from "react"
import { Button, Container, Nav, Navbar } from "react-bootstrap"
import { NavLink, Outlet } from "react-router-dom"
import axios from "axios"
import { ToastContainer } from "react-toastify"

export const Root: React.FC = () => {
  const auth = useAuth()

  const signOut = async () => {
    // This is Cognito-specific, as Cognito doesn't implement OIDC logout correctly
    await auth.signOut()
    const clientId = auth.userManager.settings.client_id
    const logoutUri = auth.userManager.settings.post_logout_redirect_uri || ""
    const signOutEndpoint = await auth.userManager.metadataService.getEndSessionEndpoint()
    window.location.href = `${signOutEndpoint}?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`
  }

  useEffect(() => {
    axios.get("/ping", {
      baseURL: process.env.REACT_APP_BACKEND_URL
    }).catch(e => console.error(e))
  }, [])

  return <>
    <ToastContainer theme="dark" />
    <Navbar bg="dark" variant="dark">
      <Container fluid>
        <Navbar.Brand href="/">Spendrift</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/spending-log">📖 Spending Log</Nav.Link>
            <Nav.Link as={NavLink} to="/savings">💰 Savings</Nav.Link>
            <Nav.Link as={NavLink} to="/accounts">🏦 Accounts</Nav.Link>
          </Nav>
          <Button variant="dark" onClick={signOut}><FontAwesomeIcon icon={faRightFromBracket} /> Sign out</Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <Container fluid>
      <Outlet />
    </Container>
  </>
}
